import { createRouter, createWebHistory } from 'vue-router'
import MarkersView from './views/MarkersView.vue';
import CategoriesView from './views/CategoriesView.vue';

const routes = [
  { name: 'home', path: '/', component: CategoriesView },
  { name: 'category', path: '/:category', component: MarkersView, props: true },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;